import React from 'react';
import propTypes from 'prop-types';

const FolderIcon = props => {
  const { className } = props;
  return (
    <div>
      <svg
        className={`folder-icon ${className}`}
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="16px"
        height="16px"
        viewBox="0 0 16 16"
        style={{ enableBackground: 'new 0 0 16 16' }}
        xmlSpace="preserve"
      >
        <path
          d="M13.3,14H2.7c-0.7,0-1.3-0.6-1.3-1.3V3.3C1.3,2.6,1.9,2,2.7,2H6l1.3,2h6c0.7,0,1.3,0.6,1.3,1.3v7.3
	C14.7,13.4,14.1,14,13.3,14z M2.7,3C2.5,3,2.3,3.1,2.3,3.3v9.3c0,0.2,0.1,0.3,0.3,0.3h10.7c0.2,0,0.3-0.1,0.3-0.3V5.3
	c0-0.2-0.1-0.3-0.3-0.3H6.8L5.5,3H2.7z"
        />
      </svg>
    </div>
  );
};
FolderIcon.propTypes = {
  className: propTypes.string,
};

export default FolderIcon;
